import { colors } from '../tokens/colors';
import { radius } from '../tokens/radius';
export const sharedCarouselTokens = {
    'carousel-max-width': '544px',
    'carousel-height': '244px',
    'carousel-border-radius': radius.xs,
    'carousel-box-shadow': '0px 2px 4px 0px rgba(0, 0, 0, 0.12)',
    'carousel-text-color': colors?.neutral?.[0] ?? '#FFFFFF',
    'carousel-pagination-gap': '4px',
    'carousel-pagination-dot-height': '4px',
    'carousel-pagination-dot-border-radius': '999px',
    'carousel-pagination-dot-inactive-width': '10px',
    'carousel-pagination-dot-active-width': '30px',
    'carousel-pagination-inactive': 'rgba(255, 255, 255, 0.6)',
};
